export const FPJS_CONFIG = {
  cacheLocation: 'sessionstorage',
  cacheTimeInSeconds: 24 * 60 * 60,
  loadOptions: {
    apiKey: import.meta.env.VITE_FPJS_API_KEY,
    endpoint: [`${import.meta.env.VITE_FPJS_ENDPOINT}/odTn3N91lA5LE1X5?region=ap`],
    region: 'ap',
    scriptUrlPattern: [
      `${import.meta.env.VITE_FPJS_ENDPOINT}/jFliXEX1Nwh3r5Si?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>`,
    ],
    urlHashing: {
      fragment: true,
      path: true,
      query: true,
    },
  },
}
